export default __webpack_public_path__ + "static/media/790.748e3509.png";